<template>
  <div class="searchResult">
    <table class="table table-sm table-hover table-striped">
      <thead>
      <tr>
        <th class="max-w-110"></th>
        <th></th>
        <th></th>
        <th v-if="project.id && project.is_active" v-for="project in projects">{{ project.name }}</th>
        <th v-for="field in extraFields">{{ fieldsNames[field] }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(record, index) in records" :key="index">
        <td class="max-w-110">
          <p><a :href="`http://rancond.info/index.php/ostatki-na-skladakh?prep=${record.id}&store=`"
                target="_blank">{{ record.prep }}</a> <span class="text-muted">({{ record.id }})</span></p>
          <p class="text-muted" v-if="record.egk || record.dop_egk">ЕГК: {{ record.egk }} {{ record.dop_egk }}</p>
          <p class="cost_price_text"><span :class="['priority','priority-' + record.priority]"></span> валюта:
            {{ record.currency }}</p>
          <p class="cost_price_text">страна: {{ $AllCountries[record.country].full_country.toUpperCase() }}</p>
          <p class="cost_price_text">
            <template v-if="getFilterValue('c3')">
              <i class="icon-fa icon-fa-rub"></i>
              {{ Math.round(record.pk_cost_price / $AllCurrencies[33].rate * 10) / 10 }} RUB
            </template>
            <template v-else>
              <i class="icon-fa icon-fa-eur"></i> {{ record.pk_cost_price }} EUR
            </template>
          </p>
          <div v-html="printData(record, 'expireDates')"/>
          <div v-html="printData(record, 'gosRegistration')"/>
        </td>
        <td>
          {{ printProfit(record) }}
        </td>
        <td></td>
        <td v-if="project.id && project.is_active" v-for="project in projects" class="projects_td">
          <div
            v-if="getActivityRecords(record.prices, project.id) && savedData[record.id] && Object.keys(savedData[record.id])">
            <div class="form-group">
              <input type="checkbox" @change="updateDataToSave(record, 'active', project.id)"
                     v-model="savedData[record.id][project.id].active" :id="`ch_a_${record.id}_${project.id}`">
              <label :for="`ch_a_${record.id}_${project.id}`">Активность</label>
            </div>
            <a
              :href="`http://rancond.info/index.php/nomenklatura/sinkhronizatsiya?editdrug=1&sid=${project.id}&morion=${record.id}`"
              target="_blank">Редактировать</a>
            <div class="form-group">
              <input type="checkbox" @change="updateDataToSave(record, 'order', project.id)"
                     v-model="savedData[record.id][project.id].order" :id="`ch_o_${record.id}_${project.id}`">
              <label :for="`ch_o_${record.id}_${project.id}`">Заказ</label>
            </div>
            <div>
              <div v-for="price in getActivityRecords(record.prices, project.id, true)">
                <div class="input-group mb-1">
                  <div class="input-group-prepend">
                    <div class="input-group-text">{{ price.qty }}</div>
                  </div>
                  <input type="text" @change="updateDataToSave(record, 'prices', project.id)"
                         v-model="savedData[record.id][project.id].prices[price.qty]" class="form-control">
                </div>
                <template v-if="getFilterValue('c11')">
                  <p class="profitPercent">
                    {{ printOverPrice(record.pk_cost_price, savedData[record.id][project.id].prices[price.qty]) }}%</p>
                </template>
              </div>
            </div>
          </div>
        </td>
        <td v-for="field in extraFields">
          <template v-if="field === 'saleStat'">
            <p v-for="(mNameInd, mInd) in monthIndex">{{ monthsNames[+mNameInd].short }}:
              {{ extraData[field][record.id] && extraData[field][record.id][mInd] || 0 }}</p>
            <template v-if="extraData.profitGrow">
              <p class="profit_grow" v-html="printSaleGrow(extraData.profitGrow[record.id])"/>
            </template>
          </template>
          <template v-if="field === 'incomePrices'">
            <p v-for="(income) in extraData[field][record.id]">{{ Math.round(income.price * 10) / 10 }}
              {{ $AllCurrencies[income.currency_id].currency }}</p>
          </template>
          <template v-if="field === 'orderStat'">
            <p v-for="(orders, oInd) in extraData[field][record.id]">{{ oInd }}: {{ orders }}</p>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  components: {
    moment,
  },
  props: ['records', 'projects', 'extraData', 'monthIndex', 'getFilterValue'],
  data () {
    return {
      savedData: {},
      updateData: {},
      extraFields: [],
      fieldsNames: {
        saleStat: 'продажи',
        incomePrices: 'закупки',
        orderStat: 'заявки',
      },
      monthsNames: {
        1: { full: 'Январь', short: 'Янв' },
        2: { full: 'Февраль', short: 'Фев' },
        3: { full: 'Март', short: 'Мар' },
        4: { full: 'Апрель', short: 'Апр' },
        5: { full: 'Май', short: 'Май' },
        6: { full: 'Июнь', short: 'Июн' },
        7: { full: 'Июль', short: 'Июл' },
        8: { full: 'Август', short: 'Авг' },
        9: { full: 'Сентябрь', short: 'Сент' },
        10: { full: 'Октябрь', short: 'Окт' },
        11: { full: 'Ноябрь', short: 'Ноя' },
        12: { full: 'Декабрь', short: 'Дек' },
      }
    }
  },
  computed: {
    $AllCountries () {
      let countries = {}
      // console.log(this.$store.getters['platform/countries']);
      // return this.$store.getters['platform/countries'];
      this.$store.getters['platform/countries'].forEach(c => {
        countries[c.id] = c
      })
      return countries
    },
    $AllCurrencies () {
      return this.$store.getters['platform/currencies']
    },
  },
  watch: {
    records () {
      this.updateSavedData()
    }
  },
  mounted () {
    this.updateSavedData()
    this.extraFields = Object.keys(this.extraData)
  },
  methods: {
    printOverPrice (costPrice, price) {
      const profitCalculation = this.getFilterValue(null, 'profitCalculation')
      // console.log(costPrice, price, profitCalculation);
      const total = costPrice * profitCalculation.calculatedRate + profitCalculation.delivery
      return Math.round(price * 100 / total) - 100
    },
    printProfit (drug) {
      const pack_set = drug.pack_set || 1
      // const costPrice = +drug.invoice_details[0].cost_price;
      const costPrice = +drug.pk_cost_price
      const price = 2980
      const costPriceRub = costPrice * this.$AllCurrencies[33].rate
      const modPrice = costPriceRub + (costPrice * 10 / 100) + 160
      const percentPrice = price * ((100 - 10) / 100) / 100 - 160
      const percentPrice2 = (price / (costPriceRub + (costPriceRub * 10 / 100) + 160) - 1) * 100
      console.log(pack_set, costPrice, price, costPriceRub, modPrice, percentPrice, percentPrice2)
      // {{record.pack_set}}<br>
      // {{record.invoice_details && record.invoice_details[0].cost_price}}<br>
      // 2980<br>
      // {{+record.invoice_details[0].cost_price + (+record.invoice_details[0].cost_price * 10 / 100) + 160}}<br>
      // {{2980 * ((100 - 10) / 100) / 100 - 160}}<br>
      // {{(2980 / (record.invoice_details[0].cost_price + (record.invoice_details[0].cost_price * 10 / 100) + 160) - 1) * 100}}

    },
    printSaleGrow (data) {
      if (!data) return
      if (!data.past) data.past = 0
      if (!data.now) data.now = 0
      const color = data.now >= data.past ? 'green' : 'red'
      const icon = data.now >= data.past ? '<i class="icon-fa icon-fa-long-arrow-up"></i>' : '<i class="icon-fa icon-fa-long-arrow-down"></i>'
      const profit = Math.round(data.now * 100 / (data.past || 1) * 10) / 10
      return '<span class="profit_' + color + '">' + icon + ' ' + profit + '%</span>'
    },
    getActivityRecords (prices, projectId, array = false) {
      let exist = false
      let records = []
      if (!prices || !prices.length) {
        return false
      }
      prices.forEach((p) => {
        if (p.site_id === projectId) {
          records.push(p)
          exist = true
        }
      })
      return array ? records : exist
    },
    updateSavedData () {
      let savedData = {}
      this.records.forEach((r) => {
        if (!savedData[r.id]) savedData[r.id] = {}
        if (r.prices && r.prices.length) {
          r.prices.forEach((p) => {
            if (!savedData[r.id][p.site_id]) {
              savedData[r.id][p.site_id] = { active: {}, prices: {}, order: {} }
            }
            savedData[r.id][p.site_id].prices[p.qty] = p.price
            savedData[r.id][p.site_id].active = p.status
            savedData[r.id][p.site_id].order = p.onstore
          })
        }
      })
      this.savedData = savedData
    },
    updateDataToSave (record, groupType, projectId) {
      if (!this.updateData[record.id]) {
        this.updateData[record.id] = {}
      }
      this.updateData[record.id][projectId] = { ...this.updateData[record.id][projectId], ...{ [groupType]: this.savedData[record.id][projectId][groupType] } }
    },
    printData (drug, type) {
      let text = ''
      switch (type) {
        case 'expireDates':
          if (drug.new_valid_dates && drug.new_valid_dates.length) {
            text += '<p><i class="icon-fa icon-fa-clock-o"></i> '
            drug.new_valid_dates.forEach((d, i) => {
              text += moment(d.expire_date).format('MM.YYYY') + ((i + 1) < drug.new_valid_dates.length ? ', ' : '')
            })
            text += '</p>'
          }
          break
        case 'gosRegistration':
          if (drug.gos_reg) {
            text += '<i class="icon-fa icon-fa-wpforms"></i> ' + (drug.gos_reg === '---' ? '<img src="/assets/icons/infinity.png" style="width:25px">' : drug.gos_reg)
          } else {
            text += 'нет регистрации'
          }
          break
      }
      return text
    }
  }
}

</script>

<style scoped>
.profitPercent {
  margin-bottom: 0;
  font-weight: 700;
}

.max-w-110 {
  max-width: 110px;
}

.table tbody td {
  font-size: 11px;
}

.table tbody .input-group .input-group-text,
.table tbody .input-group input {
  font-size: 11px;
  padding: 5px 8px;
  height: 22px;
}

.table tbody .input-group-prepend .input-group-text {
  font-weight: 600;
}

.cost_price_text {
  color: navy;
}

.priority {
  width: 12px;
  height: 12px;
  border-radius: 20px;
  display: inline-flex;
}

.priority.priority-1 {
  background-color: red;
}

.priority.priority-2 {
  background-color: yellow;
}

.priority.priority-3 {
  background-color: green;
}

.priority.priority-4 {
  background-color: gray;
}

.priority.priority-5 {
  background-color: black;
}

table.table {
  position: relative;
}

table.table thead th {
  position: sticky;
  top: 60px;
  background-color: white;
  z-index: 1;
}

table.table .projects_td {
  border-right: 1px solid #f1f1f1;
}
</style>

<style>
.searchResult table.table p,
.searchResult table.table label,
.searchResult table.table a,
.searchResult table.table .form-group {
  margin-bottom: 2px;
}

.searchResult table.table tbody td {
  vertical-align: top;
}

.searchResult table.table label {
  cursor: pointer;
}
</style>
